import React from "react";
import { Group, Text, Box } from '@mantine/core';
import { Carousel } from '@mantine/carousel';
import { utils, ROOT_BASE_URL } from "../../utils/globalVariables";
import InputWrapperCustom from "../general/InputWrapperCustom";
import videoThumbnail from "../../assets/images/video-thumbnail-1.png";

const CarouselContainer = ({ children, stateData, stateHeightImage }) => {
    return (
        <Carousel
            withIndicators={false}
            withControls={Array.isArray(stateData) && (stateData.length > 1)}
            height={stateHeightImage}
            slideSize="33.333333%"
            slideGap="xs"
            loop
            align="start"
            mt='sm'
        >
            {children}
        </Carousel>
    )
}

const MediaImageVideoCarouselDibatalkan = ({ stateData, fnClickMedia, stateMT }) => {

    const heightImage = 150;

    const [data, setData] = React.useState({
        dataImages: [],
        dataVideos: [],
    });

    React.useEffect(() => {
        const dt = stateData.data.value;

        if (Array.isArray(dt) && (dt.length > 0) && dt.some(key => key.file_type === utils.mediaQCType.image.value)) {
            setData(d => ({ ...d, dataImages: dt.filter(keyImgMedia => keyImgMedia.file_type === utils.mediaQCType.image.value) }))
        } else {
            setData(d => ({ ...d, dataImages: [] }))
        }

        if (Array.isArray(dt) && (dt.length > 0) && dt.some(key => key.file_type === utils.mediaQCType.video.value)) {
            setData(d => ({ ...d, dataVideos: dt.filter(keyVidMedia => keyVidMedia.file_type === utils.mediaQCType.video.value) }))
        } else {
            setData(d => ({ ...d, dataVideos: [] }))
        }
    }, [stateData.data.value])

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel={
                    <Group spacing={6}>
                        <Text>{stateData.data.label}</Text>
                        <Text>({Array.isArray(stateData.data.value) ? stateData.data.value.length : 0})</Text>
                    </Group>
                }
                stateWithAsterisk={stateData.data.withAsterisk}
                stateError={stateData.data.error}
                stateDescription={stateData.data.description}
                stateMT={stateMT}
            >
                {(((Array.isArray(data.dataImages) && (data.dataImages.length <= 0)) || !data.dataImages) && ((Array.isArray(data.dataVideos) && (data.dataVideos.length <= 0)) || !data.dataVideos)) &&
                    <Text size='sm' color="dimmed">Tidak ada foto dan video QC</Text>
                }

                {Array.isArray(data.dataImages) && (data.dataImages.length > 0) &&
                    <CarouselContainer
                        stateData={data.dataImages}
                        stateHeightImage={heightImage}
                    >
                        {Object.keys(data.dataImages).map((keyFB, index) => {
                            return (
                                <Carousel.Slide key={keyFB}>
                                    <Box sx={{ position: 'relative', height: heightImage + 'px' }}>
                                        <img
                                            alt={`media-qc-img-${index}`}
                                            src={ROOT_BASE_URL + data.dataImages[keyFB].file_name}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover'
                                            }}

                                            onClick={() => {
                                                fnClickMedia({
                                                    images: data.dataImages,
                                                    title: 'Media Hasil QC',
                                                    index: keyFB,
                                                    fieldName: 'file_name',
                                                    type: data.dataImages[keyFB].file_type,
                                                })
                                            }}
                                        />
                                    </Box>
                                </Carousel.Slide>
                            )
                        })}
                    </CarouselContainer>
                }

                {Array.isArray(data.dataVideos) && (data.dataVideos.length > 0) &&
                    <CarouselContainer
                        stateData={data.dataVideos}
                        stateHeightImage={heightImage}
                    >
                        {Object.keys(data.dataVideos).map((keyFB, index) => {
                            return (
                                <Carousel.Slide key={keyFB}>
                                    <Box sx={{ position: 'relative', height: heightImage + 'px' }}>
                                        <img
                                            alt={`media-qc-vid-${index}`}
                                            src={videoThumbnail}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain'
                                            }}

                                            onClick={() => {
                                                fnClickMedia({
                                                    name: `${ROOT_BASE_URL}${data.dataVideos[keyFB].file_name}`,
                                                    title: 'Media Hasil QC',
                                                    type: data.dataVideos[keyFB].file_type,
                                                })
                                            }}
                                        />
                                    </Box>
                                </Carousel.Slide>
                            )
                        })}
                    </CarouselContainer>
                }
            </InputWrapperCustom>
        </React.Fragment>
    )
}

export default MediaImageVideoCarouselDibatalkan;